import type { FC } from 'react';
import ClipboardPlus from 'assets/svg/ClipboardPlus';
import EditPencil from 'assets/svg/EditPencil';
import Trash from 'assets/svg/Trash';
import type { ChangeType } from '../types/calendar';

interface ChangeTypeEntry {
    icon: FC<{ className?: string; size?: number }>;
    rowClassName: string;
}

export const CHANGE_TYPE_CONFIG: Record<ChangeType, ChangeTypeEntry> = {
    added: {
        icon: ClipboardPlus,
        rowClassName: 'calendar-row-added',
    },
    updated: {
        icon: EditPencil,
        rowClassName: 'calendar-row-updated',
    },
    deleted: {
        icon: Trash,
        rowClassName: 'calendar-row-deleted',
    },
};
